export default __webpack_public_path__ + "static/media/chainsmokers.661d23a2.jpg";